import * as watchers from './event-group-watchers'
import { fork } from 'redux-saga/effects'

export default [
  fork(watchers.watchEventGroupLoadPage),
  fork(watchers.watchEventGroupLoadPerformances),
  fork(watchers.watchEventGroupLoadPastPerformances),
]



/** WEBPACK FOOTER **
 ** ./src/sagas/event-group/index.js
 **/